import { getIn } from "formik";
const TextArea = ({
  label,
  id,
  placeholder,
  name,
  formik,
  disabled,
  onChange,
  showError,
  onBlur,
  className,
}) => {
  const required = Object.keys(formik?.initialValues || {}).some((key) => key === name);
  const nestedError = getIn(formik?.errors, name);
  const nestedTouched = getIn(formik?.touched, name);

  return (
    <div className="relative w-full mb-4">
      <label className="block mb-1 font-bold  text-[20px] capitalize" htmlFor={id}>
        {label}
        {label && required && <span className="text-mainRed">*</span>}
      </label>
      <div>
        <textarea
          name={name}
          placeholder={placeholder}
          onChange={onChange || (formik && formik.handleChange)}
          onBlur={onBlur || (formik && formik.handleBlur)}
          value={formik?.getFieldProps(name)?.value || ""}
          disabled={disabled}
          className={`border-[#E5E7EB] border p-4 rounded-xl w-full ${className}`}
          autoComplete="off"
        />

        {(showError || !disabled) && nestedError && (showError || nestedTouched) && (
          <span className="text-[12px] w-full left-0 text-mainRed absolute bottom-[-13px]">
            {nestedError}
          </span>
        )}
      </div>
    </div>
  );
};

export default TextArea;
